import React from 'react';
import axios from '../util/Api';
import { portsKey, tokensKey } from '../util/Constants';
import getStorage from '../context/auth';
import 'antd/dist/antd.css';
import { SmileOutlined } from '@ant-design/icons';
import { Select, ConfigProvider, Spin } from 'antd';
import * as Icon from 'react-feather';

const { Option } = Select;

/* custom empty state */
const customizeRenderEmpty = () => (
  <div style={{ textAlign: 'center' }}>
    <SmileOutlined style={{ fontSize: 20 }} />
    <p>Rechercher vide</p>
  </div>
);

export default class PortSelector extends React.Component {
  state = {
    ports: [],
    selected: this.props.defaultValue
      ? { value: this.props.defaultValue.id, label: this.props.defaultValue.name }
      : undefined,
    loading: true,
  };

  componentDidMount() {
    const cached = getStorage().getItem(portsKey);
    const ONE_HOUR = 60 * 60 * 1000;

    if (cached) {
      const { date, ports } = JSON.parse(cached);
      if (Date.now() - date < ONE_HOUR) {
        this.setState({ ports, loading: false }, this.fireDefault);
        return;
      }
    }
    this.fetchData();
  }

  /* call parent again once ports are loaded */
  fireDefault = () => {
    const { selected, ports } = this.state;
    if (!selected) return;
    const port = ports.find((p) => p.id === selected.value);
    if (port) this.props.onSelected(port);
  };

  fetchData = () => {
    const token = JSON.parse(getStorage().getItem(tokensKey) || '{}');
    if (!token.jwt) return;

    axios
      .get('/api/ports/all', {
        headers: { Authorization: `Bearer ${token.jwt}` },
      })
      .then(({ status, data }) => {
        if (status === 200) {
          const ports = data.data;
          getStorage().setItem(
            portsKey,
            JSON.stringify({ date: Date.now(), ports })
          );
          this.setState({ ports, loading: false }, this.fireDefault);
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  handleChange = (option /* { value, label } */) => {
    this.setState({ selected: option });
    const port = this.state.ports.find((p) => p.id === option.value);
    if (port) this.props.onSelected(port);
  };

  render() {
    const { ports, selected, loading } = this.state;
    const selectClassName = ['mja-select', this.props.className].filter(Boolean).join(' ');
    const dropdownClassName = ['mja-select-dropdown', this.props.dropdownClassName].filter(Boolean).join(' ');

    if (loading) return <Spin />;

    return (
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <Select
          showSearch
          size="large"
          className={selectClassName}
          labelInValue
          placeholder={this.props.placeholder || "La destination"}
          style={this.props.style || { width: '100%' }}
          optionFilterProp="label"
          dropdownClassName={dropdownClassName}
          getPopupContainer={(node) => node.parentNode}
          suffixIcon={<Icon.ChevronDown size={18} />}
          value={selected}
          onChange={this.handleChange}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        >
          {ports.map((p) => (
            <Option key={p.id} value={p.id} label={p.name}>
              {p.name}
            </Option>
          ))}
        </Select>
      </ConfigProvider>
    );
  }
}
